import { Link } from "@StarberryUtils";
import * as React from "react";
import HTMLReactParser from 'html-react-parser';
import { Container, Row, Col } from "react-bootstrap";
import { GetURL } from "../../common/site/functions";
import ReadMoreComponent from "../../ReadMore/ReadMore";
import useDeviceMedia from "../../utils/useDeviceMedia";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ModalTiny from "react-bootstrap/Modal"
import ValuationFormPage from "../../forms/valuation-form";
import { CloseIcon } from "../../Icons/Icons";
import ImageModule from "../../common/Image_Module";
import "./About.scss";

// markup
const About = (props) => {
  const { isCustomMin } = useDeviceMedia({ min: "992px" });
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedFormType, setSelectedFormType] = React.useState(null);

  const openModal = (formType) => {
    setSelectedFormType(formType);
    setModalOpen(true);
  }

  const closeModal = () => {
    setModalOpen(false);
    setSelectedFormType(null);
  }

  const ggfx = [{
    ...props?.ggfx_results
  }]
  return (
    <React.Fragment>
      {props.service && props.service.map((module, i) => {
        let url = "";
        if (module.CTA_Link) {
          url = GetURL(module.CTA_Link.id);
        }

        const image_url = module?.Image?.url;

        let processedImages = JSON.stringify({});
        if (props.imagetransforms?.Modules?.Add_Service?.Image_Transforms) {
          processedImages = props.imagetransforms.Modules.Add_Service.Image_Transforms;
        }
        return (
          <section className={`about-us about-container ${module?.ImagePosition === 'Left' ? 'odd' : module?.ImagePosition === 'Right' ? 'even' : i % 2 === 0 ? 'odd' : 'even'}`} key={i}>
            <Container fluid={isCustomMin}>
              <Row className="align-items-center section-row">                
              {(module?.ImagePosition === 'Left' || (!module?.ImagePosition && i % 2 === 0)) ? (      
                  <>
                    <Col lg={6} className="d-flex px-0 block-left">
                      {module?.Image && (
                        <div className="about-img img-zoom left">
                          {/* <ImageTransform
                            imagesources={image_url}
                            renderer="srcSet"
                            imagename="articles.Modules.Add_Service.Image.service_image"
                            attr={{ alt: `${module?.Image?.alternativeText} - Dacha` }}
                            imagetransformresult={processedImages}
                            id={props.id}
                          /> */}
                          <ImageModule 
                                  ImageSrc={module?.Image } 
                                  attr={{ alt: module?.Image?.alternativeText + ' - Dacha', class: '' }} 
                                  ggfx_results={ggfx} 
                                  imagename="articles.Modules_Add_Service_Image.service_image" 
                                  strapi_id={props?.id} 
                          />    
                        </div>
                      )}
                    </Col>
                    <Col lg={6} className="d-flex block-right">
                      <div className="about-info right">
                        {module?.Title && module?.Title === "Real Estate Agents in Dubai" ?  <h1 className="about-info-title">{module?.Title} </h1>
                       : <h4 className="about-info-title">{module?.Title}</h4>}
                        {module?.Content && (
                            module?.Show_Read_More ? (
                              <ReadMoreComponent content={module.Content} wrapclass="text-sm"/>
                            ) : (
                              <div className="text-sm"> {HTMLReactParser(module.Content)}</div>
                            )
                        )}
                        {module.CTA_Modal_Form ? 
                          <div className="btn-wrap">
                            <button className="btn btn-primary abt-cta" onClick={() => openModal(module?.CTA_Modal_Form)}>
                              {module.CTA_Label}
                            </button>			
                          </div>
                          : (
                            module.CTA_Link && (
                              <div className="btn-wrap">
                                <Link className="btn btn-primary abt-cta" to={`/${url}`}>
                                  {module.CTA_Label}
                                </Link>
                              </div>
                            )
                          )
                        }
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col lg={6} className="d-flex block-left">
                      <div className="about-info left">
                        {module?.Title && <h4>{module?.Title}</h4>}
                        {module?.Content && (
                            module?.Show_Read_More ? (
                              <ReadMoreComponent content={module.Content} wrapclass="text-sm"/>
                            ) : (
                             <div className="text-sm"> {HTMLReactParser(module.Content)} </div>
                            )
                        )}
                       {module.CTA_Modal_Form ? 
                          <div className="btn-wrap">
                            <button className="btn btn-primary abt-cta" onClick={() => openModal(module?.CTA_Modal_Form)}>
                              {module.CTA_Label}
                            </button>			
                          </div>
                          : (
                            module.CTA_Link && (
                              <div className="btn-wrap">
                                <Link className="btn btn-primary abt-cta" to={`/${url}`}>
                                  {module.CTA_Label}
                                </Link>
                              </div>
                            )
                          )
                        }
                      </div>
                    </Col>
                    <Col lg={6} className="d-flex px-0 block-right">
                      {module.Image && (
                        <div className="about-img img-zoom right">
                          {/* <ImageTransform
                            imagesources={image_url}
                            renderer="srcSet"
                            imagename="articles.Modules.Add_Service.Image.service_image"
                            attr={{ alt: `${module?.Image?.alternativeText} - Dacha` }}
                            imagetransformresult={processedImages}
                            id={props.id}
                          /> */}
                          <ImageModule 
                                  ImageSrc={module?.Image } 
                                  attr={{ alt: module?.Image?.alternativeText + ' - Dacha', class: '' }} 
                                  ggfx_results={ggfx} 
                                  imagename="articles.Modules_Add_Service_Image.service_image" 
                                  strapi_id={props?.id} 
                          />  
                        </div>
                      )}
                    </Col>
                  </>
                )}
              </Row>
            </Container>
          </section>
        );
      })}      
      <ModalTiny show={modalOpen} onHide={closeModal} className="modal-form-wrapper form-valuation-wrapper">      
        <ModalTiny.Header>  
          <div class="modal-close-btn" onClick={closeModal}><CloseIcon /></div>        
          <ModalTiny.Title>
            <h4>{selectedFormType === "ValuationForm" ? "Property Valuation" : " "}</h4>
            {/* <p className="text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam nec risus nec risus convallis aliquet lipsum.</p> */}
          </ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body>
            {selectedFormType === "ValuationForm" ? <ValuationFormPage /> : ''} 
        </ModalTiny.Body>
      </ModalTiny>
    </React.Fragment>
  );
};

export default About;